module.exports = __webpack_public_path__ + "img/album14_12.b62dc2ba.jpg";